import { ItemResponses } from "@kentico/kontent-delivery"
import { getLooks, getPageByCodename } from "@lib/kontent"
import { LooksPage } from "@lib/kontent/models-deprecated/looks_page"
import { LookDetailPage } from "@lib/kontent/models-deprecated/look_detail_page"
import { PageProps } from "@lib/types"
import { ErrorPage } from "@screens/error"
import Looks from "@screens/looks"
import { NextPage } from "next"

type Props = PageProps<{
  content: LooksPage
  looks: ItemResponses.ListContentItemsResponse<LookDetailPage>
}>

const Page: NextPage<Props> = ({ statusCode, data }) => {
  if (statusCode) {
    return <ErrorPage statusCode={statusCode} />
  }
  if (!data) {
    return <ErrorPage statusCode={statusCode} />
  }

  return <Looks content={data.content} looks={data.looks} />
}

Page.getInitialProps = async ({ lang }) => {
  try {
    const content = await getPageByCodename({ codename: "looks", lang })
    const looks = await getLooks({ lang })
    if (!content) {
      return { statusCode: 404 }
    }
    return {
      data: {
        content: content.item as LooksPage,
        looks,
      },
    }
  } catch (error) {
    console.error(error)
    return { statusCode: 500 }
  }
}

export default Page
